module.exports = __webpack_public_path__ + "static/media/tom_cole_pic_2.2e927e4e.jpg";